import { Component, Input } from '@angular/core';
import { IEbComponent } from "../entitybuilder/entitybuilder.component";
import { ComponentService } from "../../services/component-service.service";

@Component({
    templateUrl: "./string.component.html",
    standalone: false
})
export class StringComponent implements IEbComponent {
    @Input() data: any;
    @Input() title: string;
    @Input() parent?: string;
    @Input() isArray?: boolean;

    constructor(public componentService: ComponentService) {
    }

    delete() {
        const serviceObj:any = {
            name: this.title,
            data: this.data,
        }
        if (this.parent) {
            serviceObj.parent = this.parent;
        }
        this.componentService.deleteObject(serviceObj);
    }

    edit() {
        const serviceObj: any = {
            name: this.title,
            data: this.data,
        }
        if (this.parent) {
            serviceObj.parent = this.parent;
        }
        this.componentService.editObject(serviceObj);
    }
}
